<div class="h-full flex flex-col bg-gray-100 rounded-2xl p-4">
  @if (order()) {
    <!-- Header with back button -->
    <div class="py-6 px-6 mb-6">
      <div class="flex items-center gap-4 mb-4">
        <button 
          class="p-2 rounded-md hover:bg-gray-200 transition-colors"
          (click)="goBack()"
        >
          <app-icon name="arrow-back" class="w-6 h-6 text-gray-700" />
        </button>
        <h2 class="text-3xl font-bold">Order Details</h2>
      </div>
    </div>

    <div class="flex-1 overflow-auto">
      <div class="bg-white rounded-2xl p-6 shadow-md">
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-8">
          <!-- Left: Photo Grid -->
          <div>
            <h3 class="text-xl font-semibold mb-4">Photos</h3>
            <app-photo-preview [photos]="photos()"></app-photo-preview>
          </div>

          <!-- Right: Order Information -->
          <div class="flex flex-col gap-4">
            <h3 class="text-xl font-semibold mb-4">Order Information</h3>
            
            <div class="text-xs text-gray-500">
              Last Updated: {{ order()!.lastUpdated.toDate() | date:'medium' }}
            </div>

            <div>
              <span class="text-gray-600">Customer: </span>
              <span class="font-semibold text-gray-900">{{ order()!.userName }} ({{ order()!.userId }})</span>
            </div>
            
            <div class="flex items-center">
              <span class="text-gray-600 mr-2">Status:</span>
              <app-status-select
                [status]="order()!.status"
                [photosDeleted]="order()!.storageImagesCleaned ?? false"
                (statusChange)="onStatusChange($event)" />
            </div>

            <app-order-deleted [order]="order()!" />
            <app-order-location [order]="order()!" />
            <app-order-properties [order]="order()!" />
            <app-order-device [order]="order()!" />

            <div class="font-bold text-3xl truncate mt-2">
              {{ ordersService.getTotalPhotos(order()) }} {{ ordersService.getTotalPhotos(order()) === 1 ? 'photo' : 'photos' }}
            </div>

            <div class="font-bold text-3xl truncate mt-2">
              <span class="font-normal text-gray-600">Price:</span>
              {{ ordersService.calculateTotalPrice(order()) | currency:'EUR':'symbol':'1.2-2':'en-US' }}
            </div>

            <!-- Download button -->
            <div class="flex justify-center mt-6">
              <button
                class="px-6 py-3 bg-blue-500 text-white rounded-lg text-lg font-semibold hover:bg-blue-600 disabled:opacity-50 disabled:cursor-not-allowed transition-colors flex items-center gap-2"
                [disabled]="
                  downloading() ||
                  !(order()!.status === 'waitingForApproval' || order()!.status === 'processing')
                "
                (click)="downloadPhotos()"
              >
                @if (downloading()) {
                  <app-icon name="spinner" class="h-5 w-5 mr-2" />
                  Downloading...
                } @else {
                  Download Photos
                }
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  } @else {
    <div class="flex items-center justify-center h-full">
      <div class="text-center text-gray-500">
        <div class="text-xl mb-2">Loading order details...</div>
      </div>
    </div>
  }
</div>
